<template>
    <div v-show="isDetailShow">

      <md-card v-show="!showExecutiveInfoOnly">
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>assignment</md-icon>임원단 이력
          </h4>
        </md-card-header>
        <md-card-content>
          <grid ref="executiveHistory"
                :data="gridProps.data"
                :columns="gridProps.columns"
                :options="gridProps.options"
                :theme="gridProps.theme"
                :rowHeaders="gridProps.rowHeaders"
                :columnOptions="gridProps.columnOptions"
                :language="gridProps.lang"
                @click="setHistoryData"
                @response="successResponse"
          ></grid>

        </md-card-content>
      </md-card>

      <!--임원단 개별정보(상세)-->
      <md-card class="search-area">
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>edit</md-icon>임원단 정보
          </h4>
        </md-card-header>

        <md-card-content>
          <table class="flex-table">
            <tr>
              <th star>교우번호</th>
              <td>
                <div class="inline-flex" v-if="selectedHisData.memberNo != ''">
                  <input type="text" readonly v-model="selectedHisData.memberNo">
                  <button @click="isShowMemberModal = true" style="display:none"><md-icon>search</md-icon></button>
                </div>
                <div class="inline-flex" v-else>
                  <input type="text" readonly v-model="selectedHisData.memberNo">
                  <button @click="isShowMemberModal = true" :disabled="!selectedHisData.isShowSave"><md-icon>search</md-icon></button>
                </div>
              </td>
              <th star>교우명</th>
              <td>
                <input type="text" disabled v-model="selectedHisData.memberHnm">
              </td>
              <th star>취임일</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="selectedHisData.erectDate" v-mask="'####-##-##'" :disabled="selectedHisData.wrkGb != 'NEW'? true: false">
                </div>
              </td>
              <th>퇴임일</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="selectedHisData.expireDate" v-mask="'####-##-##'" :disabled="!selectedHisData.isShowSave">
                </div>
              </td>
              <th star>직위</th>
              <td>
              <select v-model="selectedHisData.levelCd" :disabled="!selectedHisData.isShowSave">
              <option value="">직위 선택</option>
              <option v-for="item in memberOrgLevelList" :key="item.code" :label="item.codeNm" :value="item.code"></option>
              </select>
              </td>
            </tr>
            <tr>
              <th>대수</th>
              <td><input type="text" v-mask="'###'" v-model="selectedHisData.reign" :disabled="!selectedHisData.isShowSave"></td>
              <th star>피추천 사항</th>
              <td colspan="7">
                <label>
<!--                  <input type="radio" value="ALL" v-model="selectedHisData.memberjbGb">추천전체-->
                  <input type="radio" value="JB" v-model="selectedHisData.memberjbGb" :disabled="!selectedHisData.isShowSave">대학
                  <input type="radio" value="JN" v-model="selectedHisData.memberjbGb" :disabled="!selectedHisData.isShowSave">지부
                  <input type="radio" value="NB" v-model="selectedHisData.memberjbGb" :disabled="!selectedHisData.isShowSave">분회
                  <input type="radio" value="NN" v-model="selectedHisData.memberjbGb" :disabled="!selectedHisData.isShowSave">추천없음
                </label>
                <input type="text" class="w100" disabled v-model="searchedBranchName">
                <button @click="onClickCollegeOrBranchModal" :disabled="!selectedHisData.isShowSave"><md-icon>search</md-icon></button>
              </td>
            </tr>
            <tr>
              <th>설명</th>
              <td colspan="9">
                <textarea v-model="selectedHisData.remark" :disabled="!selectedHisData.isShowSave" maxlength="100"></textarea>
              </td>
            </tr>
          </table>

        </md-card-content>
        <md-card-actions md-alignment="right">
<!--          <md-button class="md-default md-sm" @click="clearQuery">-->
<!--            <md-icon>clear</md-icon>-->
<!--            초기화-->
<!--          </md-button>-->
          <md-button class="md-info md-sm" @click="saveExecutive" v-if="selectedHisData.isShowSave">
            <md-icon>check</md-icon>저장
          </md-button>
          <md-button class="md-default md-sm" @click="deleteExecutive">
            <md-icon>clear</md-icon>삭제
          </md-button>
        </md-card-actions>
      </md-card>
        <div>
            <branch-search-pop-comp :is-show.sync="isShowBranchModal" :branch-gb.sync="branchGb" @returnResult="callbackBranch"></branch-search-pop-comp>
            <college-search-pop-comp :is-show.sync="isShowCollegeModel" @returnResult="callbackCollege"></college-search-pop-comp>
            
          <!--교우검색 팝업 -->
          <member-search-pop-comp :is-show.sync="isShowMemberModal" @returnResult="onClickModalMember"></member-search-pop-comp>
        </div>
    </div>
</template>

<script>
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaApi from "@/kuaa/kuaa-api";
import { BranchSearchPopComp, MemberSearchPopComp, CollegeSearchPopComp } from "@/pages"
import ExcutiveSearchComp from "@/pages/Friendship/Components/ExcutiveSearchComp"
import moment from "moment";

import Swal from "sweetalert2";

import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import kuaaFormatter from "@/kuaa/kuaa-formatter";

export default {
  name: "ExcutiveDetailComp",
  props: {
    showExecutiveInfoOnly : {
      type: Boolean,
      default: false
    },
    isShow : {
      type: Boolean,
      default: false
    },
    orgLevelList: {
      type: Array,
      default() {
        return [];
      }
    },
    excutive: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {
    grid: Grid,
    BranchSearchPopComp,
    MemberSearchPopComp,
    CollegeSearchPopComp
  },

  created() {
      this.initGrid();
  },

  computed: {
      isDetailShow: function(){
          return this.isShow;
      },
      memberOrgLevelList: function() {
          return this.orgLevelList;
      }
  },

  watch: {
      excutive: function(excutiveData) {
        excutiveData.erectDate = moment(excutiveData.erectDate).format("YYYY-MM-DD");
        excutiveData.expireDate = moment(excutiveData.expireDate).format("YYYY-MM-DD");
        this.selectedHisData = excutiveData;
        this.$refs.executiveHistory.invoke("readData", 1, {memberNo:this.selectedHisData.memberNo});
        this.searchedBranchName = this.selectedHisData.branchNm;
      },
      'selectedHisData.memberjbGb': function() {
        this.searchedBranchName = "";
        this.selectedHisData.branchId = "";
        this.selectedHisData.collegeCd = "";
      }
  },

  data() {
    return {
      branchGb: null,
      isShowMemberModal : false,
      isShowCollegeModel: false,
        // 대학/지부/분회 선택
        isShowBranchModal: false,
        searchedBranchName: "",
        selectedHisData: {
            isShowSave: true,
            memberNo: "",
            memberHnm: "",
            memberorgGb: "",
            erectDate: null,
            expireDate: null,
            memberjbGb: "NN",
            remark: "",
            branchId: "",
            companyId: "",
            levelCd: "",
            userNo: "",
            workCd1: "",
            workCd2: "",
            reign: "",
            collegeCd : ""
        },
        params: {},
    }
  },
  methods: {
    clearQuery(){
      this.selectedHisData = {
        memberNo: "",
        memberHnm: "",
        memberorgGb: "",
        erectDate: null,
        expireDate: null,
        memberjbGb: "NN",
        remark: "",
        branchId: "",
        commonCd: "",
        companyId: "",
        levelCd: "",
        userNo: "",
        workCd1: "",
        workCd2: "",
        reign : "",
        collegeCd : ""
      }
    },
    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_ORG_RECORD_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.executiveHistory;
      this.gridProps['columns']= [
          {header: '대수', name: 'reign', align:"center"},
          {header: '취임일', name: 'erectDate', align:"center"},
          {header: '퇴임일', name: 'expireDate', align:"center",
            formatter(value) {
              return kuaaFnc.getDateFormatter(value.value)
            }
          },
          {header: '직위', name: 'levelNm'},
          {header: '추천구분', name: 'memberjbGbNm', align:"center"},
          {header: '추천코드', name: 'branchId', align:"center"},
          {header: '지부/분회추천명', name: 'branchNm'},
          {header: '대학추천명', name: 'collegeCdNm'},
          {header: '설명', name: 'remark', width:180}
        ];
      this.gridProps['options'].bodyHeight = 150;
    },

    successResponse(e) {
      let res = JSON.parse(e.xhr.response);
      let _this = this;
      if(!res.result){
        kuaaFnc.gridErrorCallback(e,"임원단조회 상세");
      }
      setTimeout(function () {
        let rows = _this.$refs.executiveHistory.invoke("getData");
        rows.forEach((obj)=>{
          if(obj.expireDate && obj.expireDate != ''){
            _this.$refs.executiveHistory.invoke("addRowClassName",obj.rowKey,'red');
          }
        });
      },100)
      this.$refs.executiveHistory.invoke("refreshLayout");
    },

    /**
     * Branch
     * 대학/지부/분회 검색
     */
    callbackBranch(result) {
      this.searchedBranchName = result.branchNm;
      this.selectedHisData.branchId = result.branchId;
      this.selectedHisData.collegeCd = "";
      
    },

    callbackCollege(result) {
      this.searchedBranchName = result.codeNm;
      this.selectedHisData.collegeCd = result.code;
      this.selectedHisData.branchId = "";
      
    },

    /**
     * 임원단 정보 저장
     */
    saveExecutive() {
      let modalOptions = kuaaFnc.getSwalModaloptions();
      if(!this.selectedHisData.memberNo || this.selectedHisData.memberNo == ''){
        modalOptions['html'] = '대상 교우를 선택하세요';
        Swal.fire(modalOptions);
        return;
      }

      if(!this.selectedHisData.erectDate || this.selectedHisData.erectDate == ''){
        modalOptions['html'] = '취임일을 입력 하세요';
        Swal.fire(modalOptions);
        return;
      }

      if(!this.selectedHisData.levelCd|| this.selectedHisData.levelCd == ''){
        modalOptions['html'] = '직위를 선택 하세요';
        Swal.fire(modalOptions);
        return;
      }

      // if(!this.selectedHisData.reign || this.selectedHisData.reign == ''){
      //   modalOptions['html'] = '대수를 입력 하세요';
      //   Swal.fire(modalOptions);
      //   return;
      // }

      if(this.selectedHisData.memberjbGb && this.selectedHisData.memberjbGb == 'NN'){
        this.searchedBranchName = "";
        this.selectedHisData.branchId = "";
        this.selectedHisData.collegeCd = "";
      }

      if(this.selectedHisData.memberjbGb && this.selectedHisData.memberjbGb != 'NN' && (!this.selectedHisData.collegeCd && !this.selectedHisData.branchId)){
        modalOptions['html'] = '대학 또는 [지부/분회]를 선택하세요';
        Swal.fire(modalOptions);
        return;
      }

      this.selectedHisData.searchedBranchName = this.searchedBranchName;

      Swal.fire(kuaaFnc.getSwalModaloptions('confirm',{
        html: "요청을 처리하시겠습니까?",
      })).then(result => {
        if (result.value) {
          kuaaApi.sendServer(
            URL_CONST.SAVE_ORG,
            this.selectedHisData,
            "post",
            response => {
                kuaaFnc.showSwal("임원단 정보 저장", '저장 처리 되었습니다.');
                this.$refs.executiveHistory.invoke("readData", 1, {memberNo:this.selectedHisData.memberNo});
            }
          );
        }
      });
    },
    
    setHistoryData (e){
      this.clearQuery();
      this.searchedBranchName = "";
      if(e.instance.getRow(e.rowKey) != null) {
        this.selectedHisData = e.instance.getRow(e.rowKey);
        this.searchedBranchName = this.selectedHisData.branchNm != null ? this.selectedHisData.branchNm : this.selectedHisData.collegeCdNm;
        
        if(!this.selectedHisData.expireDate){
          this.selectedHisData.isShowSave = true;
        } else {
          this.selectedHisData.isShowSave = false;
        }                                  
      }
    },
    /**
     * 임원단 정보 삭제
     */
    deleteExecutive() {
      if(!this.selectedHisData.memberNo) {
        kuaaFnc.showSwal("임원단 이력 삭제", '대상 교우를 선택하세요.');
        return;
      };

      if(!this.selectedHisData.expireDate) {
        kuaaFnc.showSwal("임원단 이력 삭제", '삭제 불가 합니다<br>[현재 임직원]');
        return;
      };


      Swal.fire(kuaaFnc.getSwalModaloptions('confirm',{
        	html: "요청을 처리하시겠습니까?",
      	})).then(result => {
        if (result.value) {
          kuaaApi.sendServer(
            URL_CONST.DELETE_ORG,
            this.selectedHisData,
            "post",
            response => {
                kuaaFnc.showSwal("임원단 이력 삭제", '삭제 처리 되었습니다.');
                this.$refs.executiveHistory.invoke("readData", 1, {memberNo:this.selectedHisData.memberNo});
                this.selectedHisData = "";
            }
	      );
        }
      });
    },

    onClickModalMember(item){
      this.selectedHisData.memberNo = item.memberNo;
      this.selectedHisData.memberHnm = item.memberHnm;
    },
    
    onClickCollegeOrBranchModal(){
      this.selectedHisData.memberjbGb == 'JB' ? this.isShowCollegeModel = true : this.isShowBranchModal = true;
      this.branchGb = this.selectedHisData.memberjbGb == 'JN'? 'J' : (this.selectedHisData.memberjbGb == 'NB'? 'B' : null);
    }
  }
}
</script>

<style lang="css" scoped>

</style>